import React from 'react';
import { Dimensions, Platform, Pressable, TouchableHighlight, View } from 'react-native'

import { findIndex as _findIndex } from 'lodash';
import PropTypes from 'prop-types';

import { VFWheelSelector, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './PaymentValues.Styles';

const PaymentValues = ({
  singleValue,
  value,
  wheelValues,
  onSelectWheelValue,
  offerValues,
  currency,
  defaultWheelValue,
  isBillingPayment,
  giftIcon,
  wheelSelectorGiftIconAccessibilityLabel,
  wheelSelectorValueAccessibilityLabel,
  wheelSelectorCurrencyAccessibilityLabel,
  theme,
  isCurrencyFirst,
  isValidTopupNumber,
  ...props
}) => {
  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View>
        {!isBillingPayment && <VFText
          style={{ marginTop: 40, marginBottom: 20, fontSize: 26, color: theme.colors.textColorTwo }}
          i18nKey={'select_amount'}
        />}
        {isBillingPayment ? <>
          <VFText
            style={[
              styles?.billingValueTextStyle(theme),
              value?.billingValueTextStyle
            ]}
            i18nKey={
              value.isCurrencyFirst
                ? `${value.currency}${(value.value - value.paidValue).toFixed(
                  2
                )}`
                : `${(value.value - value.paidValue).toFixed(2)}${value.currency
                }`
            }
          />
          {value.subTextValue && (
            <VFText
              style={[
                styles.billingValueSubTextStyle(theme),
                value.billingValueSubTextStyle
              ]}
              i18nKey={value.subTextValue}
            />
          )}
        </> :
          <View style={styles.valueWrapper}>
            {
              wheelValues?.map((item, index) => {
                const isActive = value?.value == item.value
                return (
                  <Pressable onPress={() => {
                    if (isValidTopupNumber) {
                      onSelectWheelValue(item)
                    }
                  }}>
                    <View style={[styles.value(theme, !isValidTopupNumber), styles.isActive(isActive, theme, !isValidTopupNumber)]}>
                      <VFText i18nKey={item.value} style={[styles.valueNumber, styles.isTextActive(isActive, theme, !isValidTopupNumber)]} />
                    </View>
                  </Pressable>)
              })
            }
          </View>
        }
      </View>
    )
  }
  return (
    <View
      style={
        isBillingPayment ? styles.billingPaymentView : singleValue ? styles.topupValueView : null
      }
    >
      {isBillingPayment ? (
        <>
          <VFText
            style={[styles.billingValueTextStyle(theme), value.billingValueTextStyle]}
            i18nKey={
              value.isCurrencyFirst
                ? `${value.currency}${(value.value - value.paidValue).toFixed(2)}`
                : `${(value.value - value.paidValue).toFixed(2)}${value.currency}`
            }
          />
          {value.subTextValue && (
            <VFText
              style={[styles.billingValueSubTextStyle(theme), value.billingValueSubTextStyle]}
              i18nKey={value.subTextValue}
            />
          )}
        </>
      ) : (
        <VFWheelSelector
          singleValue={singleValue}
          isCurrencyFirst={isCurrencyFirst}
          wheelValues={singleValue ? [value] : wheelValues}
          currency={currency || offerValues?.currency}
          onValueChange={onSelectWheelValue}
          giftIcon={giftIcon}
          giftIconAccessibilityLabel={wheelSelectorGiftIconAccessibilityLabel}
          valueAccessibilityLabel={wheelSelectorValueAccessibilityLabel}
          currencyAccessibilityLabel={wheelSelectorCurrencyAccessibilityLabel}
          defaultSelectedIndex={
            singleValue
              ? 0
              : defaultWheelValue && defaultWheelValue.length > 0
                ? _findIndex(
                  wheelValues,
                  wheelValue => wheelValue.value === defaultWheelValue[0].value,
                )
                : 2
          }
        />
      )}
    </View>
  );
};

PaymentValues.defaultProps = {
  titleGift: false,
  theme: LightThemeColors,
};

PaymentValues.propTypes = {
  wheelValues: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      gift: PropTypes.bool,
    }),
  ),
  offerValues: PropTypes.shape({
    giftUnit: PropTypes.string,
    giftValue: PropTypes.number,
    giftNormalPrice: PropTypes.number,
    giftOfferPrice: PropTypes.number,
    currency: PropTypes.string,
  }),
  defaultWheelValue: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      gift: PropTypes.bool,
    }),
  ),
  wheelSelectorCurrencyAccessibilityLabel: PropTypes.string,
  wheelSelectorGiftIconAccessibilityLabel: PropTypes.string,
  wheelSelectorValueAccessibilityLabel: PropTypes.string,
  lottieID: PropTypes.string,
  titleID: PropTypes.string,
  subTitleID: PropTypes.string,
  singleValue: PropTypes.bool,
  value: PropTypes.number,
  giftValue: PropTypes.string,
  currency: PropTypes.string,
  giftIcon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  titleGift: PropTypes.bool,
  isBillingPayment: PropTypes.bool,
  onSelectWheelValue: PropTypes.func,
  lottietype: PropTypes.string,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  isCurrencyFirst: PropTypes.bool,
};

export default withTheme(PaymentValues);
